import React from 'react';
import Layout from '../../components/Shared/Layout';
import AllergyAmulet from '../../components/Portfolio/allergy-amulet';
import '../../assets/css/bbqguru.css';
import * as ReactGA from 'react-ga';

const $ = typeof window !== `undefined` ? require('jquery') : null;

class Allergy_Amulet extends React.Component {
  componentDidMount() {
    ReactGA.set({
      title: 'Portfolio/food-sensor',
    });
    ReactGA.pageview(this.props.location.pathname);
  }

  render() {
    return (
      <Layout>
        <AllergyAmulet />
      </Layout>
    );
  }
}

export default Allergy_Amulet;
